import axios from 'axios';
import authService from '../features/auth/authService';
import { toast } from 'react-toastify';
import { showToast } from './toastUtils';

const instance = axios.create({
    baseURL: '', // Set your API base URL
    timeout: 100000, // Set a timeout for requests
});

instance.interceptors.request.use(
    (config) => {
        // Modify the request config here (e.g., add headers, tokens, etc.)
        config.headers.authorization = `${authService.getToken()}`;
        return config;
    },
    (error) => {
        // Handle request error
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    (response) => {
        // Handle successful responses
        const newtoken = response.headers['newtoken'];
        if (newtoken) {
            authService.setToken(newtoken)
        }
        return response;

    },
    (error) => {
        // Handle error responses
        if (error.response.status === 402) {
            localStorage.clear()
            showToast('Session has timed out. Please log in again.');
            window.location.reload();


            // Redirect to login or refresh token
            // Or any other error handling logic
        }
        return Promise.reject(error);
    }
);

export default instance;
